
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class WhatsAppGatewaySettingsGrid extends Serenity.EntityGrid<WhatsAppGatewaySettingsRow, any> {
        protected getColumnsKey() { return WhatsAppGatewaySettingsColumns.columnsKey; }
        protected getDialogType() { return WhatsAppGatewaySettingsDialog; }
        protected getIdProperty() { return WhatsAppGatewaySettingsRow.idProperty; }
        protected getInsertPermission() { return WhatsAppGatewaySettingsRow.insertPermission; }
        protected getLocalTextPrefix() { return WhatsAppGatewaySettingsRow.localTextPrefix; }
        protected getService() { return WhatsAppGatewaySettingsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}